import { storeToRefs, useAccountStore, useSocketStore } from '@/store'
import { useFetch } from '@/composables'
import WebSocketService from '@/services/websocketService'

const wsService = WebSocketService.getInstance()

export const useSocketLogin = () => {
  const accountStore = useAccountStore()
  const socketStore = useSocketStore()
  const { selectedAccount } = storeToRefs(accountStore)
  const { socketToken } = storeToRefs(socketStore)

  const { loading, data, fetchData } = useFetch<{ safe_code: string }>({
    url: '/api/trade/mt_safe_code',
    params: {
      exchange_name: selectedAccount.value?.server_name ?? '',
      loginid: selectedAccount.value?.loginid ?? '',
    },
    autoFetch: false,
  })

  const socketLogin = async () => {
    if (!wsService.isConnected()) {
      console.warn('WebSocket is not connected')
      return
    }
    try {
      await fetchData({
        exchange_name: selectedAccount.value?.server_name ?? '',
        loginid: selectedAccount.value?.loginid ?? '',
      })
      const safeCode = data.value?.safe_code ?? ''
      socketStore.setSocketToken(safeCode)
      if (safeCode) {
        wsService.send(`auth:${safeCode}`)
      }
    } catch (error) {
      console.error('Socket login failed', error)
    }
  }

  return {
    loading,
    data,
    socketToken,
    socketLogin,
  }
}
